const checkbox = {
  backgroundColor: 'transparent',
  borderColor: '#ffffff',
  marginLeft: 0,
  marginRight: 0,
  padding: 0,
};

const checkboxText = {
  fontWeight: 'normal',
  fontFamily: 'satoshi-medium',
  fontSize: 14,
  lineHeight: 19,
  color: '#6F6F6F',
};

export { checkbox, checkboxText };
